<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import {condicoesChart1, condicoesChart2 } from "../components/data-simulados";
import Swal from "sweetalert2";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import AstronautJSON from '@/assets/animations/condp_anim.json'
import exportFromJSON from "export-from-json"
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Condições de Pagamento",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      AstronautJSON,

      title: 'Condições de Pagamento',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Condições de Pagamento',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      condpgtosList: null,
      condChart1: condicoesChart1,
      condChart2: condicoesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      submitted: false,
      showModal: false,
      sortBy: 'id',
      sortDesc: true,

      regSelecionado: {
        descricao: '',
        status: 'A',
        codigo: '',
        parcelas: 1,
        interv: '',
        intervpers: '',
        qtditens: 0,
        valormin: 0,
        desconto: 0,
        personal:false,
        intervParcPersonal: []
      },
      intervaloPersonalizadoFinanParc: [],

      validations: {
        regSelecionado :{
          descricao: {
            required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
          },
          status: {
            required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
          },
          codigo: {
            required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
          },
          parcelas: {
            required: helpers.withMessage("Campo parcelas obrigatório, favor preencher.", required),
          },
          interv: {
            required: helpers.withMessage("Campo intervalo obrigatório, favor preencher.", required),
          },
        }
      },

    }
  },

  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.condpgtosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    enterParcPersonal() {
      console.log('enterParcPersonal')
      if (this.regSelecionado.personal === true) {
        this.intervaloPersonalizadoFinanParc = [];
        this.criaFinanParcPersonalizado();
      } else {
        this.$refs.interv.focus();
      }
    },

    criaFinanParcPersonalizado() {
      console.log('criaFinanParcPersonalizado')

      if (this.regSelecionado.parcelas < 2 && this.regSelecionado.personal === true ) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Atenção!",
          text: "Quantidade mínima é de 2 parcelas!",
          //confirmButtonText: "Confirmar",
          //cancelButtonText: "Cancelar",
          showCancelButton: false,
          showConfirmButton: false,
        }).then(() => {
          this.intervaloPersonalizadoFinanParc = []
          return
        })
      } else{
        for (let i = 0; i < this.regSelecionado.parcelas; i++) {
          this.intervaloPersonalizadoFinanParc.push({
            intervaloProx: this.regSelecionado.intervParcPersonal[i] ?? null,
            numeroParc: i + 1,
          })
        }
        this.regSelecionado.personal = true
      }
    },

    reiniciaParcPersonal(){
      console.log('removerParcPersonal')
      this.regSelecionado.intervParcPersonal = []
      this.regSelecionado.interv = ''
      this.enterParcPersonal()
    },

    confirmaParcPersonal(){
      console.log('confirmaParcPersonal')
      this.regSelecionado.intervParcPersonal = this.intervaloPersonalizadoFinanParc
      this.regSelecionado.interv = this.intervaloPersonalizadoFinanParc.map(item => item.intervaloProx).join('/')
    },

    atualizaDataList(){
      this.loadingList = true
      this.loadingGraph = true

      api.get(`${getBaseUrl()}api/condpgtos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'o': this.sortBy,
          'od': this.sortDesc
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.condpgtosList = res.data[0]
          this.title = `(${this.condpgtosList?.length}) Condições de Pagamento`
          this.loadingList = false
          this.loadingGraph = false
        }
      });
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)
      this.condpgtosList = null
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/condpgto`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg() {
      console.log('alterouReg_pai_0')
      const regSelecionado = this.regSelecionado
      // console.log(regSelecionado)
      this.loadingList = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/condpgto`, {
        condpgtoData: regSelecionado
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        this.loadingList = false

        if(res.data.error){
          // console.log(res.data.error)

          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          this.showModal = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.regSelecionado = {}
          this.atualizaDataList()
        }
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      }).finally(()=>{
        this.atualizaDataList()
      })
    },

    criarNova() {
      console.log('criarNova')
      this.regSelecionado = {
        descricao: '',
        status: 'A',
        codigo: '',
        parcelas: 1,
        interv: '',
        intervpers: '',
        qtditens: 0,
        valormin: 0,
        desconto: 0,
        personal:false,
        intervParcPersonal: []
      }
      this.intervaloPersonalizadoFinanParc = []
      this.showModal = true
    },

    ordenar(field) {
      console.log('sortBy')
      console.log(field)
      if (field === this.sortBy){
        this.sortDesc = !this.sortDesc
      }
      this.sortBy = field
      this.atualizaDataList()


    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.condpgtosList.find((reg) => reg.id === dataID);
      // console.log('regSelecionado: ')
      // console.log(this.regSelecionado)

      if(this.regSelecionado.personal === true){
        this.regSelecionado.interv = this.regSelecionado.intervpers
        this.intervaloPersonalizadoFinanParc = []
        this.criaFinanParcPersonalizado()
      }
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {

        if (result.value) {
          this.deletouReg(dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        this.alterouReg()
      }
    },

    setCriarNova: function() {
      this.submitted = false
      this.showModal = true
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted condicoes-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 5px; right: 250px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNova">
                    <i class="mdi mdi-plus me-1"></i> Nova Condição
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0">
              <table class="table align-middle table-nowrap table-striped table-hover"  v-if="condpgtosList">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('id')" aria-label="Ordenar">
                      ID
                    </a>
                  </th>
                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('codigo')" aria-label="Ordenar">
                      Código
                    </a>
                  </th>
                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('descricao')" aria-label="Ordenar">
                      Descrição
                    </a>
                  </th>
                  <th class="align-middle text-center">Status</th>
                  <th class="align-middle text-center">Parcelas</th>
                  <th class="align-middle text-center">Intervalo (dias)</th>
                  <th class="align-middle text-center">Tipo</th>
                  <th class="align-middle text-center">Qtd. Mínima</th>
                  <th class="align-middle text-center">Valr Mínimo</th>
                  <th class="align-middle text-center">Desconto</th>
                  <th class="align-middle text-center">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in condpgtosList" :key="data.id">
                  <td class="text-center">
                    <a href="javascript: void(0);"
                       class="text-body fw-bold"
                       @click="editar(data.id)">{{ data.id }}
                    </a>
                  </td>
                  <td class="text-center">{{ data.codigo }} </td>
                  <td class="text-center">{{ data.descricao }} </td>
                  <td class="text-center">
                    <span class="badge badge-pill badge-soft-success font-size-11" :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                      {{ nomeStatus(data.status)  }}
                    </span>
                  </td>
                  <td class="text-center">{{ formatInteger(data.parcelas) }} </td>
                  <td class="text-center">{{ data.intervpers }} </td>
                  <td class="text-center">{{ data.personal === true ? 'Personalizado' : 'Padrão' }} </td>
                  <td class="text-center">{{ formatInteger(data.qtditens) }} </td>
                  <td class="text-center">{{ formatDecimal(data.valormin) }} </td>
                  <td class="text-center">{{ formatDecimal(data.desconto) }} </td>

                  <td class="text-center">
                    <div class="button-items">
                      <b-button variant="outline-success" @click="editar(data.id)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="deletar(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!loadingGraph">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Condições Destaque Mês</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="condChart1.series"
                :options="condChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaques Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="donut"
                dir="ltr"
                :series="condChart2.series"
                :options="condChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <b-modal :title="regSelecionado.id != null ? `Editar Condição de Pagamento (${ regSelecionado.id })` : 'Criar Nova Condição de Pagamento'"
             v-model="showModal" @hidden="atualizaDataList" hide-footer>
      <form v-if="regSelecionado" @submit.prevent="formSubmit">
        <div class="row">

          <div class="d-flex justify-content-between col-12 mb-3">
            <div class="col-7">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$?.regSelecionado?.descricao?.$error}"/>
              <div
                  v-if="submitted && v$?.regSelecionado?.descricao?.$error"
                  class="invalid-feedback">
                          <span v-if="v$.regSelecionado.descricao.required.$message">
                            {{ v$.regSelecionado.descricao.required.$message }}
                          </span>
              </div>
            </div>

            <div class="col-4">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  :class="{'is-invalid': submitted && v$?.regSelecionado?.codigo?.$error}"/>
              <div
                  v-if="submitted && v$?.regSelecionado?.codigo?.$error"
                  class="invalid-feedback">
                          <span v-if="v$.regSelecionado.codigo.required.$message">
                            {{ v$.regSelecionado.codigo.required.$message }}
                          </span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between col-12">
            <div class="d-flex justify-content-between col-7">
              <div class="col-sm-4">
                <label for="valormin">Qtd. Parcelas</label>
                <input
                    id="parcelas"
                    v-model="regSelecionado.parcelas"
                    type="number"
                    class="form-control"
                    @keypress.enter="enterParcPersonal()"
                    style="margin-top: 13px"
                    placeholder="Parcelas"
                    :class="{'is-invalid': submitted && v$?.regSelecionado?.parcelas?.$error,}"/>
                <div
                    v-if="submitted && v$?.regSelecionado?.parcelas?.$error"
                    class="invalid-feedback">
                          <span v-if="v$.regSelecionado.parcelas.required.$message">
                            {{ v$.regSelecionado.parcelas.required.$message }}
                          </span>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="col-sm-7 align-items-end align-content-start float-start">
                  <label for="interv">Intervalo </label>
                  <span class="font-size-11" style="position: relative; margin-left: 1px; margin-bottom: 10px">(dias)</span>
                  <div style="position:relative; margin-top: -15px">
                    <b-form-checkbox
                        id="personal"
                        switch size="sm"
                        :disabled="regSelecionado.parcelas <= 1 || regSelecionado.parcelas === ''"
                        v-model="regSelecionado.personal">
                      {{ regSelecionado.personal === false ? 'Padrão' : 'Personalizado' }}
                    </b-form-checkbox>
                  </div>

                </div>

                <input
                    id="interv"
                    ref="interv"
                    v-model="regSelecionado.interv"
                    :type="regSelecionado.personal === true ? 'text':'number'"
                    class="form-control"
                    :disabled= "regSelecionado.personal === true"
                    placeholder="Intervalo"
                    :class="{'is-invalid': submitted && v$?.regSelecionado?.interv?.$error}"/>
                <div
                    v-if="submitted && v$?.regSelecionado?.interv?.$error"
                    class="invalid-feedback">
                  <span v-if="v$.regSelecionado.interv.required.$message">
                    {{ v$.regSelecionado.interv.required.$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-4">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  style="margin-top: 13px"
                  v-model="regSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$?.regSelecionado?.status?.$error}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$?.regSelecionado?.status?.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <!--ATENÇÃO!!!!!!-->
          <!--Pablo: Esse trecho abaixo foi comentado pois ainda não foi criado uma arquitetura/fluxo para utilização desses atributos posteriormente!-->

          <!--<div :class="regSelecionado.personal === true ? 'col-sm-3 mt-1': 'row'">
            <div :class="regSelecionado.personal === true ? 'col-sm-11 mt-3' :'col-3'">
              <div class="mb-1">
                <label for="desconto">Desconto de partida</label>
                <input
                    id="desconto"
                    v-model="regSelecionado.desconto"
                    type="number"
                    class="form-control"
                    placeholder="Desconto de partida"/>
              </div>
            </div>

            <div :class="regSelecionado.personal === true ? 'col-sm-11 mt-3' :'col-3'">
              <div class="mb-1">
                <label for="qtditens">Qtd. mínima de itens</label>
                <input
                    id="qtditens"
                    v-model="regSelecionado.qtditens"
                    type="number"
                    class="form-control"
                    placeholder="Qtd. mínima"/>
              </div>
            </div>

            <div :class="regSelecionado.personal === true ? 'col-sm-11 mt-3' :'col-3'">
              <div class="mb-1">
                <label for="valormin">Vlr. mínimo da condição</label>
                <input
                    id="valormin"
                    v-model="regSelecionado.valormin"
                    type="number"
                    class="form-control"
                    placeholder="Valor mínimo"/>
              </div>
            </div>
          </div>-->

          <div v-if="regSelecionado.personal === true" class="col-sm-8 ms-3">
            <hr>

            <div class="d-flex">
              <b-button v-if="intervaloPersonalizadoFinanParc?.length <= 0" variant="success" title="Criar novo intervalo" style="padding: 0px 10px" @click="enterParcPersonal()">
                <i class="bx bx-customize font-size-15 align-middle" style="cursor:pointer;"/>Criar intervalo
              </b-button>

              <b-button v-if="intervaloPersonalizadoFinanParc?.length > 0" variant="outline-primary" title="Reiniciar Intervalo" @click="reiniciaParcPersonal()" class="d-flex ms-auto"  style="padding: 1px 10px">
                <i class="bx bx-sync d-block font-size-16"/>Reiniciar
              </b-button>

              <b-button v-if="intervaloPersonalizadoFinanParc?.length > 0"
                        :disabled="intervaloPersonalizadoFinanParc.some(item => item.intervaloProx === null || item.intervaloProx === '') || regSelecionado.intervParcPersonal?.length > 0"
                        variant="outline-success"
                        title="Confirma Intervalo"
                        @click="confirmaParcPersonal()"
                        class="d-flex ms-2"
                        style="padding: 1px 10px">

                  <i class="bx bx-check-double d-block  font-size-16"/>Confirmar
              </b-button>

            </div>

            <div class="table-responsive mt-2" v-if="regSelecionado.personal === true" style="max-height: 400px; overflow-y: auto;">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 10%; white-space: normal;">Número Parcela</th>
                  <th scope="col" style="width: 100px; white-space: normal;">Intervalo(dias) até próx. parcela</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="data in intervaloPersonalizadoFinanParc" :key="data.id">
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <span class="text-dark">
                        {{ data.numeroParc }}
                      </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <input
                          :disabled="regSelecionado.intervParcPersonal?.length > 0"
                          type="number"
                          v-model="data.intervaloProx"
                          placeholder="Intervalo(dias)"
                          class="form-control"
                      />
                    </h5>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <hr>

          </div>


        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit" :disabled="regSelecionado.personal === true ? regSelecionado.intervParcPersonal?.length < 1 : regSelecionado.interv?.length < 1">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>

  </Layout>
</template>
